import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { salesOrdersPermissionGuard } from './core/sales-orders-permission.guard';
import { cprsPermissionGuard } from './core/cprs-permission.guard';
import { reportsPermissionGuard } from './core/reports-permission.guard';
import { administrationPermissionGuard } from './core/administration-permission.guard';
import { adminOnlyGuard } from './core/admin-only.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'manage-orders',
    loadComponent: () =>
      import('./features/manage-orders/manage-orders.component').then((m) => m.ManageOrdersComponent),
    canActivate: [authGuard]
  },
  {
    path: 'help-support',
    loadComponent: () =>
      import('./features/help-support/help-support.component').then((m) => m.HelpSupportComponent),
    canActivate: [authGuard]
  },
  {
    path: 'online-guides',
    loadComponent: () =>
      import('./features/help-support/online-guides.component').then((m) => m.OnlineGuidesComponent),
    canActivate: [authGuard]
  },
  {
    path: 'faqs',
    loadComponent: () => import('./features/help-support/faqs.component').then((m) => m.FaqsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'site-feedback',
    loadComponent: () =>
      import('./features/help-support/site-feedback.component').then((m) => m.SiteFeedbackComponent),
    canActivate: [authGuard]
  },
  {
    path: 'reports',
    loadComponent: () => import('./features/reports/reports.component').then((m) => m.ReportsComponent),
    canActivate: [authGuard, reportsPermissionGuard]
  },
  {
    path: 'reports/sales-order',
    loadComponent: () =>
      import('./features/reports/sales-order-report.component').then((m) => m.SalesOrderReportComponent),
    canActivate: [authGuard, reportsPermissionGuard]
  },
  {
    path: 'reports/billing-history',
    loadComponent: () =>
      import('./features/reports/billing-history-report.component').then((m) => m.BillingHistoryReportComponent),
    canActivate: [authGuard, reportsPermissionGuard]
  },
  {
    path: 'reports/retrieval',
    loadComponent: () =>
      import('./features/reports/retrieval-report.component').then((m) => m.RetrievalReportComponent),
    canActivate: [authGuard, reportsPermissionGuard]
  },
  {
    path: 'reports/dashboard-purchase',
    loadComponent: () =>
      import('./features/reports/dashboard-purchase-report.component').then((m) => m.DashboardPurchaseReportComponent),
    canActivate: [authGuard, reportsPermissionGuard]
  },
  {
    path: 'reports/dashboard-revenue',
    loadComponent: () =>
      import('./features/reports/dashboard-revenue-report.component').then((m) => m.DashboardRevenueReportComponent),
    canActivate: [authGuard, reportsPermissionGuard]
  },
  {
    path: 'administration',
    loadComponent: () =>
      import('./features/administration/administration.component').then((m) => m.AdministrationComponent),
    canActivate: [authGuard, administrationPermissionGuard]
  },
  {
    path: 'administration/manage-users',
    loadComponent: () =>
      import('./features/administration/administration-manage-users.component').then(
        (m) => m.AdministrationManageUsersComponent
      ),
    canActivate: [authGuard, administrationPermissionGuard]
  },
  {
    path: 'administration/manage-locations',
    loadComponent: () =>
      import('./features/administration/administration-manage-locations.component').then(
        (m) => m.AdministrationManageLocationsComponent
      ),
    canActivate: [authGuard, administrationPermissionGuard]
  },
  {
    path: 'administration/add-user',
    loadComponent: () =>
      import('./features/administration/administration-user-editor.component').then(
        (m) => m.AdministrationUserEditorComponent
      ),
    canActivate: [authGuard, administrationPermissionGuard]
  },
  {
    path: 'administration/edit-user/:id',
    loadComponent: () =>
      import('./features/administration/administration-user-editor.component').then(
        (m) => m.AdministrationUserEditorComponent
      ),
    canActivate: [authGuard, administrationPermissionGuard]
  },
  {
    path: 'administration/edit-permissions/:id',
    loadComponent: () =>
      import('./features/administration/administration-user-permissions.component').then(
        (m) => m.AdministrationUserPermissionsComponent
      ),
    canActivate: [authGuard, administrationPermissionGuard]
  },
  {
    path: 'administration/edit-preferences/:id',
    loadComponent: () =>
      import('./features/administration/administration-user-preferences.component').then(
        (m) => m.AdministrationUserPreferencesComponent
      ),
    canActivate: [authGuard, administrationPermissionGuard]
  },
  {
    path: 'administration/mass-notifications',
    loadComponent: () =>
      import('./features/administration/mass-notifications.component').then((m) => m.MassNotificationsComponent),
    canActivate: [authGuard, adminOnlyGuard]
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/auth/unauthorized.component').then((m) => m.UnauthorizedComponent)
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then((m) => m.NotFoundComponent)
  }
];
